import { collection, doc, getDoc, where } from "firebase/firestore";
import { db } from "../../firebase";

const GetSingleUserRequest = async (RequestID) => {
  try {
    const RequestCollection = collection(db, "Requests");
    const RequestDocument = await doc(RequestCollection, RequestID);
    const RequestSnapshot = await getDoc(
      RequestDocument,
      where("IsDeleted", "==", false)
    );

    let Request = { ...RequestSnapshot.data(), id: RequestSnapshot.id };

    return Request;
  } catch (error) {
    console.log(error);
  }
};

export default GetSingleUserRequest;
